import type { CSSProperties } from 'react';

/** Set as a style so Habla's own padding cannot win on emit order. */
export const pinnedButtonStyle: CSSProperties = {
  paddingLeft: 'var(--dixa-size-spacer-200)',
  paddingRight: 'var(--dixa-size-spacer-200)',
};
